import { useState, ReactNode } from 'react';
import { CursorContext, CursorState } from './cursorTypes';

export function CursorProvider({ children }: { children: ReactNode }) {
  const [cursorState, setCursorState] = useState<CursorState>('default');
  const [cursorText, setCursorText] = useState('');

  return (
    <CursorContext.Provider
      value={{ cursorState, cursorText, setCursorState, setCursorText }}
    >
      {children}
    </CursorContext.Provider>
  );
}
